import { useQuery } from '@tanstack/react-query'
import api from 'api/api'
import { getCachedAnswer } from 'state/cache'
import { resolveDirectMessageLatestAnswer } from 'lib/questStreamRenderedAnswers'

export const DIRECT_MESSAGE_INBOX_QUERY_KEY = ['direct-message-inbox']

// The viewer's conversations with messages, the most recent message first, as
// the inbox endpoint returns them. Its own query rather than the stream hook: a
// stream keeps only stream-shaped cache entries, and opening a conversation
// re-caches it as a full thread, which would drop it until the next refetch.
export default function useDirectMessageInbox(enabled: boolean) {
    const { data, isFetching } = useQuery({
        queryKey: DIRECT_MESSAGE_INBOX_QUERY_KEY,
        queryFn: () =>
            api.getQuests({
                private: true,
                private_messages: true,
                order: 'time',
                per_page: 30,
                page: 1,
            } as any),
        enabled,
        staleTime: 15_000,
    })
    const quests: any[] = ((data as any)?.quests || []).filter((quest: any) => quest?.id != null)
    return { quests, isFetching }
}

// A conversation's latest message: from the inbox payload, or by its last
// declared id from the answer cache.
export function directMessageLatestMessage(quest: any): any | null {
    const hydrated = resolveDirectMessageLatestAnswer(quest)
    if (hydrated) return hydrated
    const ids = Array.isArray(quest?.sorted_answer_ids) ? quest.sorted_answer_ids : []
    const lastId = ids.length ? ids[ids.length - 1] : null
    return lastId != null ? getCachedAnswer(String(lastId)) || null : null
}
